"use client";

import { useQuery } from "@tanstack/react-query";
import { fetchUserTeamsForLftPost } from "./fetch-user-teams-lft";

export const managedTeamsKeys = {
  all: ["lfg-board", "managed-teams"] as const,
  byUser: (userId: string) => [...managedTeamsKeys.all, userId] as const,
};

/**
 * Команды, где пользователь капитан или менеджер: по ним — авторство командных объявлений
 * и показ «Соберите свою команду». Гостю запрос не нужен.
 */
export function useManagedTeams(userId: string | undefined) {
  return useQuery({
    queryKey: managedTeamsKeys.byUser(userId ?? ""),
    queryFn: () => fetchUserTeamsForLftPost(userId ?? ""),
    enabled: !!userId,
    select: (teams) => ({
      /** Основные команды под управлением: временные и архивные к доске не относятся. */
      managed: teams.filter((t) => t.canManageLft !== false && !t.isTemporary && !t.archivedAt),
      /** Все команды, где пользователь состоит: свои объявления не откликаются. */
      memberIds: new Set(teams.map((t) => t.id)),
      /** Есть основная (не временная и не архивная) команда: баннер «Соберите свою команду» тогда не нужен. */
      hasMainTeam: teams.some((t) => !t.isTemporary && !t.archivedAt),
    }),
  });
}
